import React from 'react';

const MODEL_META = {
  fire:        { label: 'Fire & Smoke', icon: '🔥', color: 'text-red-400',    border: 'border-red-700/50' },
  fall:        { label: 'Fall',         icon: '🚨', color: 'text-orange-400', border: 'border-orange-700/50' },
  ladder:      { label: 'Ladder',       icon: '🪜', color: 'text-yellow-400', border: 'border-yellow-700/50' },
  safety_belt: { label: 'Harness',      icon: '🦺', color: 'text-blue-400',   border: 'border-blue-700/50' },
};

export default function ModelControls({ config, onChange }) {
  const update = (model, key, value) => {
    const next = { ...config, [model]: { ...config[model], [key]: value } };
    onChange(next);
  };

  return (
    <div className="flex flex-col gap-3">
      <div className="text-xs text-slate-500 uppercase tracking-wide font-semibold">
        Model Controls
      </div>

      {Object.entries(MODEL_META).map(([name, meta]) => {
        const cfg = config[name] || { enabled: true, threshold: 0.5 };
        return (
          <div key={name}
            className={`bg-surface rounded-lg p-3 border ${meta.border} transition-opacity
                        ${cfg.enabled ? 'opacity-100' : 'opacity-50'}`}>
            <div className="flex items-center justify-between mb-2">
              <div className="flex items-center gap-1.5">
                <span className="text-base">{meta.icon}</span>
                <span className={`text-sm font-medium ${meta.color}`}>{meta.label}</span>
              </div>

              {/* Toggle */}
              <button
                onClick={() => update(name, 'enabled', !cfg.enabled)}
                className={`relative inline-flex h-6 w-11 shrink-0 items-center rounded-full
                            transition-colors duration-200
                            ${cfg.enabled ? 'bg-brand' : 'bg-surface-border'}`}>
                <span className={`inline-block h-4 w-4 transform rounded-full bg-white shadow
                                  transition-transform duration-200
                                  ${cfg.enabled ? 'translate-x-6' : 'translate-x-1'}`} />
              </button>
            </div>

            {/* Threshold slider */}
            <div className="flex items-center gap-2">
              <span className="text-xs text-slate-500 w-20">threshold</span>
              <input
                type="range" min={0.30} max={0.95} step={0.05}
                value={cfg.threshold}
                onChange={e => update(name, 'threshold', parseFloat(e.target.value))}
                className="flex-1 h-1" disabled={!cfg.enabled}
              />
              <span className="text-xs text-slate-300 w-8 text-right font-mono">
                {Math.round(cfg.threshold * 100)}%
              </span>
            </div>
          </div>
        );
      })}
    </div>
  );
}
